export enum ListBuilderDownloadAs {
    SINGLE_FILE = "single",
    MULTIPLE_FILES_BY_PARENT_LIST = "by-parent",
    MULTIPLE_FILES_BY_LIST = "by-list",
    MULTIPLE_FILES_BY_SNAPSHOT = "by-snapshot",
    MULTIPLE_FILES_BY_SNAPSHOT_LIST = "by-snapshot-list",
}
